import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FileSizePipe } from '../../pipes/file-size.pipe';
import { KorviuButtonComponent } from '../korviu-button/korviu-button.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { CustomMessageService } from 'core/services/custom-message.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TagComponent } from '../tag/tag.component';
import { Statuses } from '../../types/payment-account.interface';

@Component({
  selector: 'app-upload',
  standalone: true,
  imports: [
    FileSizePipe,
    KorviuButtonComponent,
    NzIconModule,
    NzUploadModule,
    TranslateModule,
    NzButtonModule,
    TagComponent
  ],
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.scss'
})
export class UploadComponent {
  @Input() statuses: any[];
  @Input() hideUploadButton: boolean;
  @Input() dragAndDrop: boolean;
  @Input() fileList!: any[];
  @Output() fileListChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  public DocumentStatuses = Statuses;

  private _translateService = inject(TranslateService);
  private _messageService = inject(CustomMessageService);

  public getFileStatus(file: any): string {
    return this.statuses?.find(s => s.id === file.id)?.status;
  }

  public removeFile = (file: any): boolean => {
    this.fileList = this.fileList.filter((item: any) => item.id !== file.id);
    this.fileListChange.emit(this.fileList);
    return true;
  };

  public beforeUpload = (file: any): Observable<boolean> => {
    const isValidType: boolean =
      file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
    const isValidSize: boolean = file.size / 1024 / 1024 < 5;
    const isWithinLimit: boolean = this.fileList.length < 3;

    if (!isValidType) {
      this._messageService.error(this._translateService.instant('common.invalidFileType'));
      return of(false);
    }

    if (!isValidSize) {
      this._messageService.error(this._translateService.instant('common.fileSizeExceeded'));
      return of(false);
    }

    if (!isWithinLimit) {
      this._messageService.error(this._translateService.instant('common.fileLimitExceeded'));
      return of(false);
    }

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      file.thumbUrl = e.target.result;
      this.fileList = [...this.fileList, file];
      this.fileListChange.emit(this.fileList);
    };
    reader.readAsDataURL(file as any);

    file.id = file.uid;

    return of(false);
  };
}
